import React, { Component } from "react";
import "./SignUp.css";
import Header from "../../components/header/Header.js";
import { Fade } from "react-reveal";
import Footer from "../../components/footer/Footer.js";
import TopButton from "../../components/topButton/TopButton.js";

class SignUp extends Component {
  render() {
    return (
      <div className="error-main">
        <Header theme={this.props.theme} />
        <div className="error-class">
          <Fade bottom duration={2000} distance="40px">
          <div className="form-container">
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLSeTa0DeUDq_FxcVeREeNM-oJeAB995ZJLMw46_EDtpLclTplQ/viewform?embedded=true"
              width="100%"
              height="900"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              title="Sign Up Form"
              style={{ border: "none" }}
            >
              Loading...
            </iframe>
          </div>
          </Fade>
        </div>
        <Footer theme={this.props.theme} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
  
}

export default SignUp;
